// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LinksNetwork_links_network__KZpDr {
  position: fixed;
  right: 50px;
  top: 50%;
  height: 100%;
}
@media (max-width: 1420px) {
  .LinksNetwork_links_network__KZpDr {
    right: 30px;
  }
}
@media (max-width: 890px) {
  .LinksNetwork_links_network__KZpDr {
    display: flex;
    align-items: center;
    justify-content: center;
    position: static;
    width: 100%;
    height: auto;
  }
}
.LinksNetwork_links_network__KZpDr .LinksNetwork_menu__0aE4X {
  display: flex;
  flex-direction: column;
  gap: 25px;
  padding: 0;
  margin: 0;
  transform: translateY(-50%);
}
@media (max-width: 890px) {
  .LinksNetwork_links_network__KZpDr .LinksNetwork_menu__0aE4X {
    transform: translateY(0px);
    flex-direction: row;
    padding: 20px 60px;
    margin: 0;
  }
}
.LinksNetwork_links_network__KZpDr .LinksNetwork_menu__0aE4X li {
  list-style: none;
}
.LinksNetwork_links_network__KZpDr .LinksNetwork_menu__0aE4X li a {
  text-decoration: none;
}

.LinksNetwork_links_network__KZpDr a {
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}
.LinksNetwork_links_network__KZpDr a svg {
  fill: var(--red);
  transform: scale(1.3);
  transition: 0.3s;
}
.LinksNetwork_links_network__KZpDr a svg:hover {
  fill: var(--red-hover);
  transform: scale(1.4);
}

.LinksNetwork_links_network__KZpDr.LinksNetwork_home__RwcmB a {
  background-color: transparent;
}
.LinksNetwork_links_network__KZpDr.LinksNetwork_home__RwcmB a svg {
  fill: #fff;
}`, "",{"version":3,"sources":["webpack://./src/components/LinksNetwork/LinksNetwork.module.scss"],"names":[],"mappings":"AAAA;EACG,eAAA;EACA,WAAA;EACA,QAAA;EACA,YAAA;AACH;AACG;EANH;IAOM,WAAA;EAEJ;AACF;AAAG;EAVH;IAWM,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,gBAAA;IACA,WAAA;IACA,YAAA;EAGJ;AACF;AAGG;EACG,aAAA;EACA,sBAAA;EACA,SAAA;EACA,UAAA;EACA,SAAA;EACA,2BAAA;AADN;AAIM;EATH;IAUM,0BAAA;IACA,mBAAA;IACA,kBAAA;IAEA,SAAA;EAFP;AACF;AAIM;EACG,gBAAA;AAFT;AAIS;EACG,qBAAA;AAFZ;;AASG;EACG,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AANN;AAQM;EACG,gBAAA;EACA,qBAAA;EACA,gBAAA;AANT;AASM;EACG,sBAAA;EACA,qBAAA;AAPT;;AAaG;EACG,6BAAA;AAVN;AAYM;EACG,UAAA;AAVT","sourcesContent":[".links_network {\r\n   position: fixed;\r\n   right: 50px;\r\n   top:50%;\r\n   height: 100%;\r\n\r\n   @media (max-width: 1420px) {\r\n      right: 30px;\r\n   }\r\n\r\n   @media (max-width: 890px) {\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: center;\r\n      position: static;\r\n      width: 100%;\r\n      height: auto;\r\n   }\r\n\r\n   // @media (max-height: 650px) {\r\n      // padding-top: 380px;\r\n   // }\r\n\r\n   .menu {\r\n      display: flex;\r\n      flex-direction: column;\r\n      gap: 25px;\r\n      padding: 0;\r\n      margin: 0;\r\n      transform:translateY(-50%);\r\n\r\n      \r\n      @media (max-width: 890px) {\r\n         transform:translateY(0px);\r\n         flex-direction: row;\r\n         padding: 20px 60px;\r\n         // height: auto;\r\n         margin: 0;\r\n      }\r\n\r\n      li {\r\n         list-style: none;\r\n\r\n         a {\r\n            text-decoration: none;\r\n         }\r\n      }\r\n   }\r\n}\r\n\r\n.links_network {\r\n   a {\r\n      background-color: #fff;\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: center;\r\n      border-radius: 50%;\r\n\r\n      svg {\r\n         fill: var(--red);\r\n         transform: scale(1.3);\r\n         transition: 0.3s;\r\n      }\r\n\r\n      svg:hover {\r\n         fill: var(--red-hover);\r\n         transform: scale(1.4);\r\n      }\r\n   }\r\n}\r\n\r\n.links_network.home {\r\n   a {\r\n      background-color: transparent;\r\n\r\n      svg {\r\n         fill: #fff;\r\n      }\r\n   }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"links_network": `LinksNetwork_links_network__KZpDr`,
	"menu": `LinksNetwork_menu__0aE4X`,
	"home": `LinksNetwork_home__RwcmB`
};
export default ___CSS_LOADER_EXPORT___;
